export default "__VITE_ASSET__CYbvHwux__"